import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=4f4ea9c3&scoped=true&"
import script from "./BlankLayout.vue?vue&type=script&lang=js&"
export * from "./BlankLayout.vue?vue&type=script&lang=js&"
import style0 from "./BlankLayout.vue?vue&type=style&index=0&id=4f4ea9c3&lang=less&scoped=true&"
import style1 from "./BlankLayout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ea9c3",
  null
  
)

export default component.exports